import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import {
  MitsBadgeColor,
  MitsBadgeComponent,
  MitsBadgeSize,
} from "./mits-badge.component";

@Component({
  selector: "mits-badge",
  template: "",
})
export class MockMitsBadgeComponent implements Partial<MitsBadgeComponent> {
  /** Value of the badge */
  @Input() value: string | number = "0";
  /** Color of the badge */
  @Input() color: MitsBadgeColor = "primary";
  /** Very small title on top of the badge */
  @Input() title: string = "";
  /** Should the bagde be displaed as an outlined badge? */
  @Input() outlined: boolean = false;
  /** Defines the size of the badge */
  @Input() size: MitsBadgeSize = "default";

  @ViewChild("mitsBadgeSpan") mitsBadgeSpanComp: ElementRef<HTMLSpanElement>;
}
